
//  export const URL_BACKEND = 'https://api.rnpm.org.pe/api';
// export const URL_IMAGE = 'https://rnpm.org.pe';

export const URL_BACKEND = 'https://apetac.org/api';
export const URL_IMAGE = 'https://apetac.org/';


